import Dropdown, {
  DropdownItem,
  DropdownCheckedItem,
  DropdownButton,
  StyledDropdownButton,
} from './Dropdown';
import Icon from './Icon';
import ListItemTopBar from './ListItemTopBar';
import Loader from './Loader';
import FieldLabel from './FieldLabel';
import IconButton from './IconButton';
import Toggle, { ToggleContainer, ToggleBackground, ToggleHandle } from './Toggle';
import AuthenticationPage from './AuthenticationPage';
import WidgetPreviewContainer from './WidgetPreviewContainer';
import ObjectWidgetTopBar from './ObjectWidgetTopBar';
import GoBackButton from './GoBackButton';
import {
  fonts,
  colorsRaw,
  colors,
  lengths,
  components,
  buttons,
  text,
  shadows,
  borders,
  transitions,
  effects,
  zIndex,
  reactSelectStyles,
  GlobalStyles,
} from './styles';

export const NetlifyCmsUiDefault = {
  Dropdown,
  DropdownItem,
  DropdownCheckedItem,
  DropdownButton,
  StyledDropdownButton,
  ListItemTopBar,
  FieldLabel,
  Icon,
  IconButton,
  Loader,
  Toggle,
  ToggleContainer,
  ToggleBackground,
  ToggleHandle,
  AuthenticationPage,
  WidgetPreviewContainer,
  ObjectWidgetTopBar,
  fonts,
  colorsRaw,
  colors,
  lengths,
  components,
  buttons,
  shadows,
  text,
  borders,
  transitions,
  effects,
  zIndex,
  reactSelectStyles,
  GlobalStyles,
};
export {
  Dropdown,
  DropdownItem,
  DropdownCheckedItem,
  DropdownButton,
  StyledDropdownButton,
  ListItemTopBar,
  FieldLabel,
  Icon,
  IconButton,
  Loader,
  Toggle,
  ToggleContainer,
  ToggleBackground,
  ToggleHandle,
  AuthenticationPage,
  WidgetPreviewContainer,
  ObjectWidgetTopBar,
  fonts,
  colorsRaw,
  colors,
  lengths,
  components,
  buttons,
  shadows,
  text,
  borders,
  transitions,
  effects,
  zIndex,
  reactSelectStyles,
  GlobalStyles,
  GoBackButton,
};
